
import { Briefcase, CheckCircle, Trophy, BarChart, BriefcaseBusinessIcon, TrendingDown } from "lucide-react";
import CountUp from "react-countup";
import { useGetAnalyticsQuery } from "../../redux/api/profile.api";

interface Props {
    isDashboarad?: boolean
}

export const AnalyticsCard = ({ isDashboarad = false }: Props) => {
    const { data: statistics, error, isLoading } = useGetAnalyticsQuery()


    if (isLoading) {
        return (
            <div className="flex items-center  flex-1 overflow-hidden py-2 justify-center min-w-max h-[30vh] bg-white dark:bg-[#212121]">
                <div className="w-12 h-12 border-4 border-t-transparent border-accent-500 rounded-full animate-spin"></div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="p-4 bg-red-50 text-red-500 rounded-lg border border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800">
                <div className="flex items-center gap-6">
                    <p>Error: {error.message}</p>
                    <button
                        onClick={() => {
                            window.location.reload();
                        }}
                        className="flex items-center gap-2 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-accent-600 transition duration-200"
                    >
                        <span className="text-sm ">Retry</span>
                    </button>
                </div>
            </div>
        )
    }

    const stats = [
        {
            label: "Interviews",
            value: statistics?.totalInterviews,
            icon: <Briefcase className="h-5 w-5" />,
            color: "from-blue-500 to-blue-600",
            bgColor: "bg-blue-100 dark:bg-blue-900/50",
            textColor: "text-blue-600 dark:text-blue-400",
        },
        {
            label: "Positions",
            value: statistics?.positions,
            icon: <BriefcaseBusinessIcon className="h-5 w-5" />,
            color: "from-orange-500 to-orange-600",
            bgColor: "bg-orange-100 dark:bg-orange-900/50",
            textColor: "text-orange-600 dark:text-orange-400",
        },
        {
            label: "Completed",
            value: statistics?.completed,
            icon: <CheckCircle className="h-5 w-5" />,
            color: "from-green-500 to-green-600",
            bgColor: "bg-green-100 dark:bg-green-900/50",
            textColor: "text-green-600 dark:text-green-400",
        },
        {
            label: "Highest Score",
            value: statistics?.maxScore,
            isPercent: true,
            icon: <Trophy className="h-5 w-5" />,
            color: "from-yellow-500 to-yellow-600",
            bgColor: "bg-yellow-100 dark:bg-yellow-900/50",
            textColor: "text-yellow-600 dark:text-yellow-400",
        },
        {
            label: "Average Score",
            value: statistics?.avgScore,
            isPercent: true,
            icon: <BarChart className="h-5 w-5" />,
            color: "from-purple-500 to-purple-600",
            bgColor: "bg-purple-100 dark:bg-purple-900/50",
            textColor: "text-purple-600 dark:text-purple-400",
        },
        {
            label: "Lowest Score",
            value: statistics?.minScore,
            isPercent: true,
            icon: <TrendingDown className="h-5 w-5" />,
            color: "from-red-500 to-red-600",
            bgColor: "bg-red-100 dark:bg-red-900/50",
            textColor: "text-red-600 dark:text-red-400",
        },
    ]



    return (
        <div className={`w-full max-w-[86rem] grid grid-cols-2   gap-1 mt-3 h-full mb-8 ${isDashboarad ? " mobile:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" : "mobile:grid-cols-2  sm:grid-cols-3 lg:grid-cols-2 2xl:grid-cols-3"}`}>
            {stats.map((item, idx) => (
                <div
                    key={idx}
                    className="group bg-gradient-to-br from-white to-gray-50/50 dark:from-[#212121] dark:to-[#212121]/50 rounded-2xl p-2  border border-gray-200/50 dark:border-gray-700/50 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 backdrop-blur-sm"
                >
                    <div className="flex items-center gap-4">
                        <div
                            className={`w-10 h-10 ${item.bgColor} rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}
                        >
                            <div className={item.textColor}>{item.icon}</div>
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-baseline gap-1">
                                <span className="text-xl font-bold text-gray-900 dark:text-white tabular-nums">
                                    <CountUp end={item.value || 0} duration={2.5} separator="," />
                                </span>
                                {item.isPercent && !!item.value && (
                                    <span className="text-lg font-semibold text-gray-600 dark:text-gray-400">%</span>
                                )}
                            </div>
                            <p className="text-xs font-medium text-gray-600 dark:text-gray-400 truncate">{item.label}</p>
                        </div>
                    </div>

                    {/* Progress indicator for percentage values
                    {item.isPercent && item.value && (
                        <div className="mt-4 w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 overflow-hidden">
                            <div
                                className={`h-full bg-gradient-to-r ${item.color} rounded-full transition-all duration-1000 ease-out`}
                                style={{ width: `${Math.min(item.value, 100)}%` }}
                            />
                        </div>
                    )} */}
                </div>
            ))}
        </div>
    )
}